import {
    FEATURE_LINE_PICK_RADIUS_PX,
    FEATURE_POINT_PICK_RADIUS_PX,
    SKETCH_LINE_PICK_RADIUS_PX,
    SKETCH_POINT_PICK_RADIUS_PX,
} from '../../../constants/solidworks-picking';

/**
 * 解析线对象的屏幕空间拾取半径。
 *
 * @param isFeatureLine 当前线是否为实体特征线。
 * @param linewidth 材质声明线宽；缺失时传入 null。
 * @returns 屏幕空间拾取半径，单位为像素。
 */
export function resolveScreenSpaceLinePickRadiusPx(
    isFeatureLine: boolean,
    linewidth: number | null,
): number {
    const baseRadius = isFeatureLine ? FEATURE_LINE_PICK_RADIUS_PX : SKETCH_LINE_PICK_RADIUS_PX;
    const renderedHalfWidth = linewidth === null ? 0 : Math.max(0, linewidth * 0.5);

    /**
     * 拾取半径必须至少覆盖真实渲染半宽，避免线宽变大后出现“看得到但选不到”；
     * 同时特征线基础半径收敛到 4px，避免默认 3px 线宽被扩大到 10px 热区。
     */
    return Math.max(baseRadius, renderedHalfWidth);
}

/**
 * 解析点对象的屏幕空间拾取半径。
 *
 * @param isFeaturePoint 当前点是否为实体特征点。
 * @param scaleX 对象当前 scale.x；缺失时传入 null。
 * @returns 屏幕空间拾取半径，单位为像素。
 */
export function resolveScreenSpacePointPickRadiusPx(
    isFeaturePoint: boolean,
    scaleX: number | null,
): number {
    const baseRadius = isFeaturePoint ? FEATURE_POINT_PICK_RADIUS_PX : SKETCH_POINT_PICK_RADIUS_PX;
    if (scaleX === null) {
        return baseRadius;
    }

    /**
     * Sprite 点的可见尺寸由 scale 驱动，拾取半径需要跟随放大的可见点，
     * 但不能低于基础半径，否则默认小点会难以命中。
     */
    return Math.max(baseRadius, scaleX * 600);
}
